export const apiConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};
